import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
  /** Mindest-Breite in px für den Tabellen-Inhalt — erzwingt horizontal scroll auf schmalen Viewports. */
  minWidth?: number;
}

export function CountryTableScroll({ children, minWidth = 540 }: Props) {
  return (
    <div className="overflow-x-auto" style={{ WebkitOverflowScrolling: "touch" }}>
      <div style={{ minWidth }}>{children}</div>
    </div>
  );
}
